import React from "react";
import { useNavigate } from "react-router-dom";
import { MenuDivider, MenuItem, MenuList, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useUserSessionStore } from "@/stores/v2/userSessionStore";
import { colours } from "@/utils/themeUtils";
import { fonts } from "@/theme/fonts";

export interface CurrentUserPopupProps {
	onOpenAccountSettings: () => void;
}

export function CurrentUserPopup(props: CurrentUserPopupProps): JSX.Element {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const userSessionStore = useUserSessionStore();
	const activeUser = userSessionStore.getActiveUser() ?? "";

	function handleLogout() {
		navigate("/login", { state: { logout: true } });
	}

	return (
		<MenuList
			py={2}
			px={0}
			minW="260px"
			borderRadius="lg"
			boxShadow="lg"
			borderWidth="1px"
			borderColor="gray.100"
			bg="white"
			fontFamily={fonts.body}
		>
			<MenuItem
				onClick={props.onOpenAccountSettings}
				flexDirection="column"
				alignItems="flex-start"
				py={3}
				px={4}
				bg="transparent"
				color={colours.text.body}
				_hover={{ bg: "gray.50" }}
				_focus={{ bg: "gray.50" }}
				data-testid="account-settings-menu-item"
			>
				<Text fontFamily={fonts.heading} fontWeight={500} fontSize="14px" lineHeight="20px" color={colours.text.body}>
					{t("account.myAccountSettings")}
				</Text>
				{activeUser ? (
					<Text
						fontFamily={fonts.body}
						fontWeight={400}
						fontSize="12px"
						lineHeight="16px"
						color={colours.blueGray[400]}
						mt={1}
						noOfLines={2}
					>
						{activeUser}
					</Text>
				) : null}
			</MenuItem>

			<MenuDivider my={1} borderColor="gray.100" />

			<MenuItem
				onClick={handleLogout}
				py={3}
				px={4}
				bg="transparent"
				color={colours.text.body}
				fontFamily={fonts.body}
				fontWeight={500}
				fontSize="14px"
				lineHeight="20px"
				_hover={{ bg: "gray.50" }}
				_focus={{ bg: "gray.50" }}
			>
				{t("account.signOut")}
			</MenuItem>
		</MenuList>
	);
}
